export default function parseJwt(token) {
  try {
    const tokenData = JSON.parse(atob(token.split('.')[1]));
    const userObj = {};
    userObj.name = tokenData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    userObj.email = tokenData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'];
    // eslint-disable-next-line dot-notation
    userObj.tokenExpiry = parseInt(tokenData['exp'], 10);
    return userObj;
  } catch (e) {
    return null;
  }
}
